module.exports = __webpack_public_path__ + "img/tick-mark.f8b73073.svg";